const ALREADY_SEEN_MEMBER_PROMO_OFFER = 'ALREADY_SEEN_MEMBER_PROMO_OFFER';

export default ALREADY_SEEN_MEMBER_PROMO_OFFER;
